/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  DeleteApiV1PersonIdMutationResponse,
  DeleteApiV1PersonIdPathParams,
  DeleteApiV1PersonId401,
  DeleteApiV1PersonId404,
  DeleteApiV1PersonId500,
} from "../../types/personRegisterController/DeleteApiV1PersonId.ts";

function getDeleteApiV1PersonIdUrl(id: DeleteApiV1PersonIdPathParams["id"]) {
  const res = { method: "DELETE", url: `/api/v1/person/${id}` as const };
  return res;
}

/**
 * @description Tenta excluir permanentemente. Se houver dependências, desativa a pessoa (soft delete). **(Requer Authorization para autenticação)**
 * @summary Excluir pessoa (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id}
 */
export async function deleteApiV1PersonId(
  id: DeleteApiV1PersonIdPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiV1PersonIdMutationResponse,
    ResponseErrorConfig<
      DeleteApiV1PersonId401 | DeleteApiV1PersonId404 | DeleteApiV1PersonId500
    >,
    unknown
  >({
    method: "DELETE",
    url: getDeleteApiV1PersonIdUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
